export function truncateString(text, options){
  const max = options.max;
  return text && text.length > max ? text.substring(0, max) + '...' : text;
}